<template>
  <div>
    <navbar>
      <div class="navbar-wrapper">
        <img style="width: 60%; padding: 10px 0px 0 20px;" src="/static/img/alideda-logo-light.png" alt="">
      </div>
      <template slot="navbar-menu">
        <!-- Languages -->
        <drop-down tag="li" position="right" class="nav-item" :title="$ml.get(appLanguage.toLowerCase())" icon="now-ui-icons location_world">
          <button v-for="lang in $ml.list" class="dropdown-item" :key="lang"
                  @click="$ml.change(lang); setLanguage(lang)">{{$ml.get(lang.toLowerCase())}}</button>
        </drop-down>

        <router-link class="nav-item" tag="li" to="/auth/register">
          <a class="nav-link">
            <i class="now-ui-icons tech_mobile"></i>
            {{ $ml.get('register') }}
          </a>
        </router-link>

        <router-link class="nav-item" tag="li" to="/auth/login">
          <a class="nav-link">
            <i class="now-ui-icons users_circle-08"></i>
            {{ $ml.get('login') }}
          </a>
        </router-link>
      </template>

    </navbar>
    <div class="wrapper wrapper-full-page">
      <div class="full-page section-image" :class="pageClass" data-image="">
        <div class="content">
          <div class="container">
            <zoom-center-transition :duration="200" mode="out-in">
              <router-view></router-view>
            </zoom-center-transition>
          </div>
        </div>
        <footer class="footer">
          <div class="container-fluid">
            <nav>
              <ul>
              </ul>
            </nav>
            <div class="copyright">&copy; {{year}}, {{$ml.get('copyright')}}. <a href="https://alideda.com/">Alideda</a>.</div>
          </div>
        </footer>

        <div class="full-page-background" style="background-image: url('')"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { Navbar } from '../components';
import { ZoomCenterTransition } from 'vue2-transitions';
import { mapGetters, mapActions } from 'vuex';
export default {
  components: {
    Navbar,
    ZoomCenterTransition
  },
  data() {
    return {
      year: new Date().getFullYear(),
      pageClass: 'login-page'
    };
  },
  mounted() {
    if (localStorage.getItem('role') && !['admin', 'reseller', 'client'].includes(localStorage.getItem('role'))) {
      localStorage.removeItem('role');
      localStorage.removeItem('token');
      localStorage.removeItem('CompanyId');
    }

    if(localStorage.getItem('token') && localStorage.getItem('role')){
      return this.$router.push('/' +  localStorage.getItem('role') + '/');
    }
  },
  methods: {
    ...mapActions(['setLanguage']),
    setPageClass() {
      this.pageClass = `${this.$route.name.replace('Auth', '').toLowerCase()}-page`.toLowerCase();
    }
  },
};
</script>
<style lang="scss">
$scaleSize: 0.8;
@keyframes zoomIn8 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  100% {
    opacity: 1;
  }
}
.wrapper-full-page .zoomIn {
  animation-name: zoomIn8;
}
@keyframes zoomOut8 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.wrapper-full-page .zoomOut {
  animation-name: zoomOut8;
}
</style>
